'use strict';

import Cookies from "js-cookie";

const darkScheme     = 'dark';
const lightScheme    = 'light';
const darkSchemeCss  = '/assets/css/app-dark.css';

function setModeType(isDark) {
    const systemScheme = Cookies.get('preferred_color_scheme');
    if (darkScheme !== systemScheme) {
        $("#app-style").attr('href', darkSchemeCss);
    }
    Cookies.set('preferred_color_scheme', isDark ? darkScheme : lightScheme,
        {expires: new Date(2121, 1, 1, 1, 1, 1)});
}

export function colorSchemeOnStart() {
    if ('system' === $("#app-style").data('mode')) {
        let isDarkDefaultAppMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
        setModeType(isDarkDefaultAppMode);
    }
}
